<template>
  <div
    class="drag-drop-input-wrapper"
    :class="{
      'drag-drop-input--disabled': disabled,
    }"
    @click="openFileDialog"
    @keydown.enter.prevent="openFileDialog"
    @keydown.space.prevent="openFileDialog"
    @dragenter.prevent="onDragEnter"
    @dragover.prevent="onDragOver"
    @dragleave.prevent="onDragLeave"
    @drop.prevent="onDrop"
  >
    <div
      class="drag-drop-input"
      :class="{
        'drag-drop-input--active': isDragOver,
      }"
    >
      <input
        ref="input"
        class="drag-drop-input__input"
        type="file"
        :accept="accept"
        :multiple="multiple"
        :disabled="disabled"
        @change="onInputChange"
      >

      <div class="drag-drop-input__content">
        <slot
          v-if="!isDragOver && files.length"
          name="filesContent"
        >
          <span class="drag-drop-input__text">
            File selected
          </span>
        </slot>

        <template v-else>
          <span v-if="isDragOver">Drop a file to upload</span>
          <span v-else>Drag and drop an image or click to upload</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModernDragDropInput',

  props: {
    accept: {
      type: String,
      default: '',
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    files: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isDragOver: false,
      dragCounter: 0,
      // files: [],
    };
  },

  methods: {
    openFileDialog() {
      if (this.disabled) {
        return;
      }

      this.$refs.input.click();
    },

    onInputChange(event) {
      const files = this.normalizeFiles(event.target.files);

      this.emitFiles(files);

      this.$refs.input.value = '';
    },

    onDragEnter() {
      if (this.disabled) {
        return;
      }

      this.dragCounter += 1;
      this.isDragOver = true;
    },

    onDragOver() {
      if (this.disabled) {
        return;
      }

      this.isDragOver = true;
    },

    onDragLeave() {
      if (this.disabled) {
        return;
      }

      this.dragCounter -= 1;

      if (this.dragCounter <= 0) {
        this.dragCounter = 0;
        this.isDragOver = false;
      }
    },

    onDrop(event) {
      if (this.disabled) {
        return;
      }

      this.dragCounter = 0;
      this.isDragOver = false;

      const files = this.normalizeFiles(event.dataTransfer.files);

      this.emitFiles(files);
    },

    normalizeFiles(fileList) {
      const files = Array.from(fileList);

      return this.multiple ? files : files.slice(0, 1);
    },

    emitFiles(files) {
      if (!files.length) {
        return;
      }

      this.$emit('update:files', files);
      this.$emit('select', files);
    },
  },
};
</script>

<style scoped lang="stylus">
.drag-drop-input-wrapper
  height 100%
  width 100%
  min-height 120px
  cursor pointer
  overflow hidden
  background-color #f2f2f2
  &--disabled
    pointer-events none
    opacity 0.6
  & .drag-drop-input
    position relative
    padding 24px
    height 100%
    width 100%
    transition border-color 0.2s ease, background-color 0.2s ease
    &::before
      content: "";
      position: absolute;
      inset: 6px;
      pointer-events: none;
      background:
        repeating-linear-gradient(
          to right,
          #bdbdbd 0 16px,
          transparent 16px 28px
        ) top left / 100% 2px no-repeat,
        repeating-linear-gradient(
          to right,
          #bdbdbd 0 16px,
          transparent 16px 28px
        ) bottom left / 100% 2px no-repeat,
        repeating-linear-gradient(
          to bottom,
          #bdbdbd 0 16px,
          transparent 16px 28px
        ) top left / 2px 100% no-repeat,
        repeating-linear-gradient(
          to bottom,
          #bdbdbd 0 16px,
          transparent 16px 28px
        ) top right / 2px 100% no-repeat;
    &:focus
      border-color #409eff
      outline none
    &--active
      background-color #ecf5ff
      border-color #409eff
    &__input
      display none
    &__content
      width 100%
      height 100%
      display flex
      justify-content center
      align-items center
      &__text
        color #606266
        overflow-wrap anywhere
</style>
